import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router : Router){}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot):  boolean 
    {

  if (localStorage.getItem('UserData') != null)
      return true;
      this.router.navigate(['/signin']);
      return false;
  }
}



// if (localStorage.getItem('DoctorData') != null)
//     {
//       //return true;

//         const data = JSON.parse(localStorage.getItem('DoctorData'));
//         let userRoles = data.Role;
//         const role = next.data.role;
//         if(role && userRoles.length > 0)
//         {
//          if(userRoles.includes(role))
//           {
//             return true;
//           }
//           this.router.navigate(['/doctor/login']);
//           return false;
  
//          }
  
        
  
      
//     }
    
//     else
//     {
//     this.router.navigate(['/doctor/login']);
//     return false;
//     }